import { render, staticRenderFns } from "./allMark.vue?vue&type=template&id=bf4d0e92&"
import script from "./allMark.vue?vue&type=script&lang=js&"
export * from "./allMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports